"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.compressFormQuestion = void 0;
const lib_logger_1 = __importDefault(require("@opsbase/lib-logger"));
const FormQuestionControllerRegistry_1 = __importDefault(require("../FormQuestionController/FormQuestionControllerRegistry"));
function compressFormQuestion(q) {
    if (!FormQuestionControllerRegistry_1.default[q.type])
        return undefined;
    try {
        return {
            qId: q.qId,
            originalQId: q.originalQId,
            title: q.title,
            titleAlt: q.titleAlt || {},
            type: q.type,
            config: FormQuestionControllerRegistry_1.default[q.type].compress(q),
            answer: q.answer,
        };
    }
    catch (e) {
        lib_logger_1.default.error('Problem compressing form question', { q, e });
        throw e;
    }
}
exports.compressFormQuestion = compressFormQuestion;
exports.default = compressFormQuestion;
